<template>
    <div id="wap">
        <div :style="{width:'100%',height:screenHeight+'px',position:'absolute',top:0,left:0}">
            <div class="swiper-container wap_slider" :style="{width:'100%',height:'100%'}">
                <div class="swiper-wrapper" :style="{width:'100%',height:'100%'}">
                    <div class="swiper-slide slide4" :style="{width:'100%',height:'100%'}">
                        <div class="content4">
                            <p class="content_title"><span>10</span>年深耕医药行业</p>
                            <p class="desc">我要的知识和服务</p>
                            <img src="../../static/wap_images/logo_1.png" alt="">
                            <div class="download_now" @click="getUserAgent">
                                <span>立即下载</span>
                            </div>

                        </div>
                        <arrow id="c4"/>
                    </div>
                    <div class="swiper-slide slide5" :style="{width:'100%',height:'100%'}">
                         <DownLoadApp/>
                        <div class="content5">
                            <p class="content_title">微解药</p>
                            <p class="desc">新知识，新方法，新E药经理人全在“微解药”</p>
                            <img src="../../static/wap_images/slide2_ban.png" alt="">
                        </div>
                        <arrow id="c5"/>
                    </div>
                    <div class="swiper-slide slide6" :style="{width:'100%',height:'100%'}">
                        <DownLoadApp/>
                        <div class="content6">
                            <p class="content_title">产品介绍</p>
                            <p class="desc">五大王牌 放心之选</p>
                            <div class="content_wrapper">
                                <div class="proBg pro_1 pull-left">
                                    <div>
                                        <p>课程</p>
                                        <p>涵盖行业知识系统掌握</p>
                                    </div>
                                </div>
                                <div class="proBg pro_2 pull-left">
                                    <div>
                                        <p>天天听书</p>
                                        <p>名人推荐，牛人解读</p>
                                    </div>
                                </div>
                                <div class="proBg pro_3 pull-left">
                                    <div>
                                        <p>商学院</p>
                                        <p>每个医药人都必须上</p>
                                        <p>的商学院</p>
                                    </div>
                                </div>
                                <div class="proBg pro_4 pull-left">
                                    <div>
                                        <p>行业大会</p>
                                        <p>医药行业的会议管家</p>
                                    </div>
                                </div>
                                <div class="proBg pro_5 pull-left">
                                    <div>
                                        <p>行业资讯聚焦</p>
                                        <p>每天直播解读最新资讯</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <arrow id="c6"/>
                    </div>
                    <div class="swiper-slide slide3" :style="{width:'100%',height:'100%'}">
                        <DownLoadApp/>
                        <div class="content3">
                            <p class="content_title">大咖在微解药</p>
                            <p class="desc">今天听什么由你决定</p>
                            <div class="content_wrapper">
                                <div class="polygon">
                                    <div class="polygon_child">
                                        <div class="round_big round_big1"></div>
                                        <div class="round_small round_small1"></div>
                                        <div class="round_big round_big2">
                                            <img src="../../static/images/guoyunpei.png" alt="guoyunpei">
                                        </div>
                                        <div class="round_big round_big3"></div>
                                        <div class="round_middle round_middle1"></div>
                                        <div class="round_middle round_middle2"></div>
                                        <div class="round_big round_big4">
                                            <img src="../../static/images/tanyong.png" alt="tanyong">
                                        </div>
                                        <div class="round_middle round_middle3">
                                            <img src="../../static/images/group_10.png" alt="group_10">
                                        </div>
                                        <div class="round_middle round_middle4">
                                            <img src="../../static/images/group_11.png" alt="group_10">
                                        </div>
                                        <div class="round_middle round_middle5"></div>
                                        <div class="round_middle round_middle6"></div>
                                        <div class="round_small round_small2"></div>
                                        <div class="round_small round_small3"></div>
                                    </div>
                                </div>
                            </div>
                            <arrow id="c3"/>
                        </div>
                    </div>
                    <div class="swiper-slide slide2" :style="{width:'100%',height:'100%'}">
                        <DownLoadApp/>
                        <div class="content2">
                            <p class="content_title">商学院</p>
                            <p class="desc">持续推动中国医药企业进入全球医药行业三甲之列全力打造医药行业人才大学</p>
                            <div class="content_wrapper">
                                <div class="sxy1">
                                    <span>走进华为线下活动-医药行业唯一合作伙伴</span>
                                </div>
                                <div class="sxy2">
                                    <span>共建一所未来医药大学</span>
                                </div>
                                <div class="sxy3">
                                    <span>提高医药行业人才核心竞争力</span>
                                </div>
                                <img src="../../static/wap_images/phone.png" alt="">
                            </div>
                        </div>
                        <arrow id="c2"/>
                    </div>
                    <div class="swiper-slide slide1" :style="{width:'100%',height:'100%'}">
                        <DownLoadApp/>
                        <div class="content1">
                            <p class="content_title">免费专区</p>
                            <p class="desc">最新行业资讯天天独家解读，名人座谈读懂行业政策市场、营销</p>
                            <div class="swiper-container" id="content_swiper">
                                <div class="swiper-wrapper" style="padding-bottom: 20px">
                                    <div class="swiper-slide">
                                        <img src="../../static/wap_images/book_1.png" alt="">
                                    </div>
                                    <div class="swiper-slide">
                                        <img src="../../static/wap_images/book_2.png" alt="">
                                    </div>
                                </div>
                                <!-- 如果需要分页器 -->
                                <div class="swiper-pagination" id="mianfei_pagination"></div>
                            </div>
                        </div>
                        <!--<arrow id="c1"/>-->
                    </div>
                </div>
                <!--&lt;!&ndash;如果需要分页器 &ndash;&gt;-->
                <!--<div class="swiper-pagination" id="wap_slider"></div>-->

            </div>
        </div>
    </div>
</template>

<script>
    import Swiper from 'swiper';
    import DownLoadApp from '@/components/common/downLoadApp';
    import arrow from '@/components/common/arrow';

    export default {
        name: "wap",
        computed: {
            screenHeight() {
                return window.innerHeight || document.documentElement.clientHeight
            }
        },
        components: {
            DownLoadApp,
            arrow
        },
        methods:{

            //判断机型
            getUserAgent(){
                var u = navigator.userAgent, app = navigator.appVersion;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                if (isAndroid) {
                    window.open('https://download.weijieyao.com/weijieyao_android_setup.apk')
                }
                if (isIOS) {
                    window.open('https://app.weijieyao.com/mum/web/h5/download/index.html')
                }
            },

            swiperInit(){
                var mySwiper = new Swiper('.wap_slider', {
                    freeMode: false,
                    direction: 'vertical',
                    //mousewheel : true,
                    autoplayDisableOnInteraction:false,
                    autoplay: {
                        stopOnLastSlide: false,
                        disableOnInteraction: false,
                        delay: 1000000
                    },
                    loop: false,

                    // 如果需要分页器
                    // pagination: {
                    //     el: '.wap_P_slider',
                    //     clickable: true,
                    //     // bulletActiveClass: 'my-bullet-active',
                    // },

                })
                var mySwipers = new Swiper('#content_swiper', {
                    freeMode: false,
                    direction: 'horizontal',
                    mousewheel: true,
                    autoplay: {
                        stopOnLastSlide: false,
                        disableOnInteraction: false,
                        delay: 3000
                    },
                    nested: true,
                    loop: true,
                    // 如果需要分页器
                    pagination: {
                        el: '#mianfei_pagination',
                        clickable: true,
                        // bulletActiveClass: 'my-bullet-active',
                    },

                })
            }
        },
        updated(){
            this.swiperInit()
        },
        mounted() {
            this.swiperInit();
        }
    }
</script>

<style scoped lang="scss">
    .slide1 {
        background-color: #f6f6f6;
        background-repeat: no-repeat !important;
        background-position: center center;
        background-size: cover !important;
    }

    .slide2 {
        background-color: #f6f6f6;
        background-repeat: no-repeat !important;
        background-position: center center;
        background-size: cover !important;

    }

    .slide3 {
        background-color: #f6f6f6;
        background-repeat: no-repeat !important;
        background-position: center center;
        background-size: cover !important;

    }

    .slide4 {
        background-color: #f6f6f6;
        background-repeat: no-repeat !important;
        background-position: center center;
        background-size: cover !important;

    }

    .slide5 {
        background-color: #f6f6f6;
        background-repeat: no-repeat !important;
        background-position: center center;
        background-size: cover !important;

    }

    .slide6 {
        background-color: #f6f6f6;
        background-repeat: no-repeat !important;
        background-position: center center;
        background-size: cover !important;
    }

    .content1 {
        width: 3.2rem;
        margin: 0 auto;
        text-align: center;
        > .content_title {
            margin-top: .4rem;
            font-size: .2rem;
            font-weight: bolder;
        }
        > .desc {
            margin-top: .1rem;
            color: #a8a8a8;
            font-size: .14rem;
        }
        > p {

        }
        #content_swiper {
            /*width: 3.4rem;*/
            height: 3.3rem;
            margin-top: .25rem;
            #mianfei_pagination {
                background: url("../../static/wap_images/bookshelves.png") no-repeat center bottom;
                background-size: 100% 100%;
                margin-top: 10px;
            }
            img {
                width: 2.19rem;
                height: 3.1rem;
            }
            .swiper-pagination-bullets {
                bottom: 0px !important;
                left: 0;
                width: 100%;
                padding: 5px 0 10px;
            }
        }
    }

    .content2 {
        width: 3.2rem;
        margin: 0 auto;
        text-align: center;
        .content_wrapper{
            margin-top: .58rem;
            img{
                margin-top: .5rem;
                width: 3.3rem;
                height: .7rem;
            }
        }
        > .content_title {
            margin-top: .4rem;
            font-size: .2rem;
            font-weight: bolder;
        }
        > .desc {
            margin-top: .1rem;
            color: #a8a8a8;
            font-size: .14rem;
        }
        .sxy1{
            width: 3rem;
            height: .4rem;
            background: url("../../static/wap_images/sxy2.png") no-repeat center center;
            background-size: cover;
            span{
                line-height:  .4rem;
                color: #fff;
                font-size: .14rem;
            }
        }
        .sxy2{
            width: 1.9rem;
            height: .4rem;
            margin-top: .4rem;
            background: url("../../static/wap_images/sxy1.png") no-repeat center center;
            background-size: cover;
            span{
                line-height:  .4rem;
                color: #fff;
                font-size: .14rem;
            }
        }
        .sxy3{
            width: 2.24rem;
            height: .4rem;
            margin-top: .4rem;
            margin-left: 35%;
            background: url("../../static/wap_images/sxy3.png") no-repeat center center;
            background-size: cover;
            span{
                line-height:  .4rem;
                color: #fff;
                font-size: .14rem;
            }
        }
    }

    .content3{
        width: 3.2rem;
        margin: 0 auto;
        text-align: center;
        > .content_title {
            margin-top: .4rem;
            font-size: .2rem;
            font-weight: bolder;
        }
        > .desc {
            margin-top: .1rem;
            color: #a8a8a8;
            font-size: .14rem;
        }
        .polygon {
            width: 3.2rem;
            height: 3.2rem;
            background: url('../../static/images/polygon_bg.gif') no-repeat center center;
            background-size: cover;
            margin-top: .4rem;
            .polygon_child {
                width: 3.2rem;
                height: 3.2rem;
                background: url('../../static/images/polygon.jpg') no-repeat center center;
                background-size: 90%;
                position: absolute;
                left: 50%;
                transform: translate(-50%);
                > div {
                    position: absolute;
                }
                .round_big {
                    width: .5rem;
                    height: .5rem;
                    border-radius: 50%;
                    background: #fff;
                    box-shadow: 0 0 5px #ccc;

                }
                .round_small {
                    width: .3rem;
                    height: .3rem;
                    border-radius: 50%;
                    background: #fff;
                    box-shadow: 0 0 5px #ccc;
                }
                .round_middle {
                    width: .4rem;
                    height: .4rem;
                    border-radius: 50%;
                    background: #fff;
                    box-shadow: 0 0 5px #ccc;
                }
                .round_big1 {
                    left: 50%;
                    transform: translate(-50%);
                }
                .round_small1 {
                    top: 21%;
                    left: .1rem;
                }
                .round_big2 {
                    top: 18%;
                    left: 25%;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .round_big3 {
                    top: 18%;
                    left: 58%;

                }
                .round_middle1 {
                    top: 20%;
                    left: 90%;
                }
                .round_middle2 {
                    top: 44%;
                    left: 12%;

                }
                .round_big4 {
                    top: 43%;
                    left: 43%;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .round_middle3 {
                    top: 45%;
                    left: 74%;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .round_middle4 {
                    top: 68%;
                    left: -2%;
                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
                .round_middle5 {
                    top: 68%;
                    left: 27%;
                }
                .round_middle6 {
                    top: 68%;
                    left: 60%;
                }
                .round_small2 {
                    top: 69%;
                    left: 90%;
                }
                .round_small3 {
                    top: 94%;
                    left: 46%;
                }
            }

        }
    }

    .content4{
        width: 100%;
        height: 80%;
        background: url("../../static/wap_images/bg.png") no-repeat center top;
        background-size: 100%;
        text-align: center;
        > .content_title {
            padding-top: .8rem;
            span{
                font-size: .28rem;
            }
            font-size: .28rem;
            font-weight: bolder;
            color: #fff;
        }
        > .desc {
            margin-top: .1rem;
            font-size: .22rem;
            color: #fff;
            letter-spacing: .1rem;
            padding-bottom: .9rem;
        }
        >img{
            width: .85rem;
        }
        >.download_now{
            width: 2.5rem;
            height: .5rem;
            background: #15b2b2;
            font-size: .16rem;
            line-height: .5rem;
            color: #fff;
            margin: .75rem auto 0;
            border-radius: .3rem;
        }

    }

    .content5{
        width: 3.4rem;
        margin: 0 auto;
        text-align: center;
        > .content_title {
            margin-top: .4rem;
            font-size: .2rem;
            font-weight: bolder;
        }
        > .desc {
            margin-top: .1rem;
            color: #a8a8a8;
            font-size: .14rem;
        }
        >img{
            margin-top: .4rem;
            width: 98%;
           box-shadow:  0 0 10px #ccc ;
            border-top-left-radius: .2rem;
            border-top-right-radius: .2rem;
        }
    }

    .content6{
        width: 3.4rem;
        margin: 0 auto;
        text-align: center;
        > .content_title {
            margin-top: .4rem;
            font-size: .2rem;
            font-weight: bolder;
        }
        > .desc {
            margin-top: .1rem;
            color: #a8a8a8;
            font-size: .14rem;
        }
        .content_wrapper{
            overflow: hidden;
            height: 3.9rem;
            margin-top: .25rem;
            .proBg{
                width: 1.3rem;
                height: 1.5rem;
                background-size: cover!important;
                >div{
                    margin-top: .75rem;
                    p{
                        color: #fff;
                        font-size: .12rem;
                    }
                    p:first-of-type{
                        font-size: .14rem;
                    }
                }
            }
            .pro_1{
                background: url("../../static/wap_images/pro_1.png") no-repeat center center;
                margin-right: .1rem;
            }
            .pro_2{
                background: url("../../static/wap_images/pro_2.png") no-repeat center center;
            }
            .pro_3{
                background: url("../../static/wap_images/pro_3.png") no-repeat center center;
                margin-right: .1rem;
                transform: translate(54%,-20%);
            }
            .pro_4{
                background: url("../../static/wap_images/pro_4.png") no-repeat center center;
                transform: translate(54%,-20%);
            }
            .pro_5{
                background: url("../../static/wap_images/pro_5.png") no-repeat center center;
                margin-left: .1rem;
                transform: translate(100%,-40%);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/wap.vue